
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 17 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.719 0c.563 0 1.104.21 1.502.586.399.375.623.884.623 1.414 0 .53-.224 1.04-.623 1.414A2.194 2.194 0 013.72 4c-.564 0-1.104-.21-1.503-.586A1.942 1.942 0 011.594 2c0-.53.224-1.04.622-1.414A2.194 2.194 0 013.72 0zM2.125 5h3.188c.563 0 1.104.21 1.502.586.399.375.622.884.622 1.414v5.5H5.845V20h-4.25v-7.5H0V7c0-.53.224-1.04.622-1.414A2.194 2.194 0 012.125 5zm11.156-5c.564 0 1.104.21 1.503.586.398.375.622.884.622 1.414 0 .53-.224 1.04-.622 1.414-.399.375-.94.586-1.503.586s-1.104-.21-1.502-.586A1.942 1.942 0 0111.156 2c0-.53.224-1.04.623-1.414C12.177.21 12.718 0 13.28 0zm-1.594 5h3.188c.564 0 1.104.21 1.503.586C16.776 5.96 17 6.47 17 7v5.5h-1.594V20h-4.25v-7.5H9.562V7c0-.53.224-1.04.623-1.414A2.194 2.194 0 0111.687 5z"}})])
          )
        }
      }
    